/* eslint-disable react/prop-types */ // TODO: add props
import { Popover } from 'react-bootstrap';
import _ from 'lodash';

/** Components */
import TrafficLightIndicator from './TrafficLightIndicator';

const MultiChoiceQuestionAverageCell = ({ question, average }) => {
  if (!_.isNumber(average)) {
    return (
      <td key={question.id} className="cell">
        -
      </td>
    );
  }

  // Format the average
  // average = Math.round10(100 * this.props.average, -1);

  const popoverText = `${average}% of your students answered this question correctly`;
  const popover = <Popover id={_.uniqueId()}>{popoverText}</Popover>;

  return (
    <div className="indicator-container">
      <TrafficLightIndicator
        a={average}
        b={question.vcaa_average}
        popover={popover}
      >
        {`${average}%`}
      </TrafficLightIndicator>
    </div>
  );
};

export default MultiChoiceQuestionAverageCell;
